import React, { useRef, useEffect, useState } from 'react';

import { Box, Typography, Tab, IconButton } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import { TabContext, TabList, TabPanel } from '@mui/lab';

import AppModal from '../../../../../components/AppModal';

import DevicesSettingsVideo from './DevicesSettingsVideo';
import DevicesSettingsGeneral from './DevicesSettingsGeneral';
import DevicesSettingsSound from './DevicesSettingsSound';
import { DevicesSettingsModalViewProps } from './interfaces';

import { useStyles } from './styles';
import GamecastStats from '../../DashboardContent/GameCast/GamecastStats';
import { useMytaverseEvent } from '../../../providers';
import { IGamecastVideoStats } from '../../DashboardContent/GameCast/interfaces';
import { useZoom } from '../../DashboardContent/Zoom/ZoomProvider';

const DevicesSettingsModalView = ({
  open,
  handleClose,
  checkVideo,
  setCheckVideo,
  settingsTab,
  setSettingsTab,
  translate,
}: DevicesSettingsModalViewProps) => {
  const classes = useStyles();
  const { gamecastStats, canSpeak } = useMytaverseEvent();

  const handleClick = () => {
    setCheckVideo(false);
    handleClose();
  };

  const intervalRef = useRef<NodeJS.Timeout>();
  const [stats, setStats] = useState({} as IGamecastVideoStats);

  // dirty fix to render GameCast stats
  useEffect(() => {
    setStats(gamecastStats.current as IGamecastVideoStats);

    intervalRef.current = setInterval(() => {
      if (open) {
        setStats(gamecastStats.current as IGamecastVideoStats);
      }
    }, 2000);

    return () => {
      clearInterval(intervalRef.current);
    }
  });

  return (
    <AppModal onClick={handleClick} isOpen={open} sx={classes.modal}>
      <Box sx={classes.title} component="div">
        <Box component="div" sx={classes.titleWrapper}>
          <SettingsIcon />
          <Typography sx={classes.titleName}>
            {translate('settingsModal.settings')}
          </Typography>
        </Box>
        <IconButton onClick={handleClose} sx={classes.titleButton}>
          <CloseIcon />
        </IconButton>
      </Box>
      <TabContext value={settingsTab}>
        <Box sx={classes.tablistRoot} component="div">
          <TabList
            onChange={(event: React.SyntheticEvent, tab: any) =>
              setSettingsTab(tab)
            }
            sx={classes.tablist}
          >
            <Tab
              value="sound"
              label={
                <Box sx={classes.tab} component="div">
                  <Typography>{translate('settingsModal.sound')}</Typography>
                </Box>
              }
              sx={classes.tabSelect}
            />
            {canSpeak ? (
              <Tab
                value="camera"
                label={
                  <Box sx={classes.tab} component="div">
                    <Typography>{translate('settingsModal.camera')}</Typography>
                  </Box>
                }
                sx={classes.tabSelect}
              />
            ) : null}
            <Tab
              value="general"
              label={
                <Box sx={classes.tab} component="div">
                  <Typography>{translate('settingsModal.general')}</Typography>
                </Box>
              }
              sx={classes.tabSelect}
            />
            <Tab
              value="stats"
              label={
                <Box sx={classes.tab} component="div">
                  <Typography>Stats</Typography>
                </Box>
              }
              sx={classes.tabSelect}
            />
          </TabList>
          <Box sx={classes.tabContentWrap} component="div">
            <Box sx={classes.tabContent} component="div">
              <DevicesSettingsSound />
              <DevicesSettingsVideo
                checkVideo={checkVideo}
                setCheckVideo={() => setCheckVideo(!checkVideo)}
              />
              <DevicesSettingsGeneral />
              <TabPanel value="stats">
                <GamecastStats stats={stats} />
              </TabPanel>
            </Box>
          </Box>
        </Box>
      </TabContext>
    </AppModal>
  );
};

export default DevicesSettingsModalView;
